/* eslint-disable no-lone-blocks */
/* eslint-disable no-console */
/* eslint-disable max-len */
/* eslint-disable no-unused-vars */
import { AnimatePresence, motion } from 'framer-motion';
import moment from 'moment';
import React from 'react';
import { GenerateDate } from '../../redux/helper/DateConverter';
import { CDN } from '../../constants';

function DistributorHeder({ Details, isLoaded }) {
    const handleImage = (img) => (img !== undefined ? `${CDN}/${img}` : '/images/profile_picture_user_icon_153847.png');

    return (
        <AnimatePresence>
            <motion.div
                key={isLoaded}
                animate={{ opacity: 1, y: 0 }}
                initial={{ opacity: 0, y: 20 }}
                exit={{ opacity: 0, y: -20 }}
                transition={{ duration: 0.15 }}
            >
                <div className="rounded-lg w-full bg-[#FFFFFF] border border-[#EBEBEB] shadow-s5 pt-4 pl-[22px] pr-7 pb-7 flex">
                    <div className="w-1/2">
                        <div className="flex items-center">
                            <motion.img
                                animate={{ opacity: 1 }}
                                initial={{ opacity: 0.5 }}
                                src={handleImage(Details?.profile_image_url)}
                                alt="profile-icon"
                                style={{ width: 50, height: 50 }}
                            />
                            <div className="pl-7">
                                {Details.FIRST_NAME === null
                                    ? <p className="text-3xl font-bold text-[#090406]">{Details.PARTY_NAME}</p>
                                    : (
                                        <p className="text-3xl font-bold text-[#090406]">
                                            {Details.FIRST_NAME}
                                            {' '}
                                            {Details.LAST_NAME}
                                        </p>
                                    ) }
                                <p className="text-xl font-normal text-[#A1A1A1]">{Details.ACCOUNT_NUMBER}</p>
                            </div>
                        </div>
                        <div className="pt-[26px]">
                            <p className="text-xs7 font-normal text-[#A1A1A1]">Registered on</p>
                            <p className="text-xs7 font-normal text-[#090406]">
                                {' '}
                                {GenerateDate(Details.CREATION_DATE)}
                            </p>
                        </div>
                        <div className="pt-2.5 flex">
                            <div className="">
                                <p className="text-xl font-normal text-[#A1A1A1]">Mobile Number</p>
                                {(Details?.PRIMARY_PHONE_NUMBER === null || Details?.PRIMARY_PHONE_NUMBER === ' ')
                                    ? <p className="text-xl font-normal text-[#090406] ml-12">-</p>
                                    : <p className="text-xl font-normal text-[#090406]">{Details.PRIMARY_PHONE_NUMBER}</p>}
                            </div>
                            <div className="pl-[46px]">
                                <p className="text-xl font-normal text-[#A1A1A1]">Email Address</p>
                                {
                                    (Details?.EMAIL_ADDRESS === null)
                                        ? <p className="text-xl font-normal text-[#090406] ml-10">-</p>
                                        : <p className="text-xl font-normal text-[#090406]">{Details.EMAIL_ADDRESS}</p>
                                }
                            </div>
                        </div>
                        <div className="pt-4">
                            <p className="text-xs5 font-normal text-[#555259]">
                                Last Logged in on :
                                {' '}
                                <span className="text-[#090406]">{Details.LAST_LOGIN_DATETIME === null ? '-' : moment(Details.LAST_LOGIN_DATETIME).format('DD-MMM-YYYY, HH:mm:ss')}</span>
                            </p>
                        </div>
                    </div>
                    <div className="w-1/2">
                        <p className="text-lg font-normal text-[#A1A1A1]">Company Name</p>
                        <p className="text-xs8 font-bold text-[#090406]">{Details.PARTY_NAME}</p>
                        <div className="pt-[18px] flex">
                            <div className="w-1/2">
                                <p className="text-xl font-normal text-[#A1A1A1]">Contact Number</p>
                                <p className="text-xl font-normal text-[#090406] pt-2.5">{Details?.SECONDARY_PHONE_NUMBER === null ? '-' : Details.SECONDARY_PHONE_NUMBER }</p>
                            </div>
                            <div className="w-1/2">
                                <p className="text-xl font-normal text-[#A1A1A1]">Company Email Address</p>
                                <p className="text-xl font-normal text-[#090406] pt-2.5">{Details?.EMAIL_ADDRESS === null ? '-' : Details.EMAIL_ADDRESS }</p>
                            </div>
                        </div>
                        <div className="pt-[18px] flex">
                            <div className="w-1/2">
                                <div className="flex">
                                    <p className="text-xl font-normal text-[#A1A1A1]">GSTIN.</p>
                                    {((Details?.GSTIN) && (Details?.GSTIN === null))
                                        ? <p className="text-xl font-normal text-[#090406] pl-[26px]">-</p>
                                        : <p className="text-xl font-normal text-[#090406] pl-[26px]">{Details.GSTIN}</p>}
                                </div>
                                <div className="pt-1 flex">
                                    <p className="text-xl font-normal text-[#A1A1A1]">PAN No.</p>
                                    <p className="text-xl font-normal text-[#090406] pl-[16px]">{(Details?.PAN_NUMBER) && (Details?.GSTIN === null) ? '-' : Details.PAN_NUMBER}</p>
                                </div>
                            </div>
                            {/* Commenting This section as per externals request */}
                            {/* <div className="w-1/2">
                                <div className="flex">
                                    <p className="text-xl font-normal text-[#A1A1A1]">Virtual Payment Account No.</p>
                                    <p className="text-xl font-normal text-[#090406] pl-[26px]">
                                        {Details?.virtual_account_info ? Details?.virtual_account_info.receivers[0].account_number : '-'}
                                        {' '}
                                    </p>
                                </div>
                                <div className="pt-1 flex">
                                    <p className="text-xl font-normal text-[#A1A1A1]">Virtual Payment IFSC No.</p>
                                    <p className="text-xl font-normal text-[#090406] pl-[16px]">
                                        {Details?.virtual_account_info ? Details?.virtual_account_info.receivers[0].ifsc : '-'}
                                        {' '}

                                    </p>
                                </div>
                            </div> */}
                        </div>
                    </div>
                </div>
            </motion.div>
        </AnimatePresence>
    );
}

export default DistributorHeder;
